module.exports = __webpack_public_path__ + "img/commit.4094231a.png";